<div class="table-contents" *ngIf="(errors | async ).length>0">

    <a class="btn btn-danger errors" data-toggle="collapse" href="#collapseErrors" role="button" aria-expanded="false"
        aria-controls="collapseErrors">
        <div class="rcn-icon-container">
          <i class="rcn-icon rcn-icon-mdi-error"
            aria-hidden="true"
            [attr.aria-labelledby]="'form-errors-label-' + stepid"
            [matTooltip]="'Section non complétée'">
          </i>
          <span [id]="'form-errors-label-' + stepid" class="rcn-sr-only">
            <span *ngIf="(errors | async ).length == 1" [translate]="erreurMessages.erreurByStep"
              [translateParams]="{ value: errorLength }"></span>
            <span *ngIf="(errors | async ).length > 1" [translate]="erreurMessages.erreursByStep"
              [translateParams]="{ value: errorLength }"></span>
          </span>
        </div>
        <span  *ngIf="(errors | async ).length == 1" [translate]="erreurMessages.erreurByStep"
            [translateParams]="{ value: errorLength }"></span>
        <span  *ngIf="(errors | async ).length > 1" [translate]="erreurMessages.erreursByStep"
            [translateParams]="{ value: errorLength }"></span>
            </a>

            <div class="alert alert-danger collapse" id="collapseErrors" role="alert">
                <div *ngFor="let fieldError of errors | async">
                    <a (click)="scrollToFragment(fieldError.fieldName, $event)" [fragment]="fieldError.fieldName"
                        [routerLink]="linkForRouter">
                        {{fieldError.errorMessage | translate}}
                    </a>
                </div>
            </div>
            </div>

            <div class="table-contents" *ngIf="(warnings | async ).length > 0 ">

    <a class="btn btn-warning warnings" data-toggle="collapse" href="#collapseWarnings" role="button" aria-expanded="false"
        aria-controls="collapseWarnings">
        <div class="rcn-icon-container">
          <i class="rcn-icon rcn-icon-mdi-warning"
            aria-hidden="true"
            [attr.aria-labelledby]="'form-warnings-label-' + stepid"
            [matTooltip]="'Section soumise à alerte'">
          </i>
          <span [id]="'form-warnings-label-' + stepid" class="rcn-sr-only">
            <span *ngIf="(warnings | async ).length == 1" [translate]="erreurMessages.warningByStep"
              [translateParams]="{ value: warningLength }"></span>
            <span *ngIf="(warnings | async ).length > 1" [translate]="erreurMessages.warningsByStep"
              [translateParams]="{ value: warningLength }"></span>
          </span>
        </div>
        <span  *ngIf="(warnings | async ).length == 1" [translate]="erreurMessages.warningByStep"
            [translateParams]="{ value: warningLength }"></span>
        <span  *ngIf="(warnings | async ).length > 1" [translate]="erreurMessages.warningsByStep"
            [translateParams]="{ value: warningLength }"></span>
    </a>

    <div class="alert alert-warning collapse" id="collapseWarnings" role="alert">
        <div *ngFor="let fieldWarning of warnings | async">
            <a [fragment]="fieldWarning.fieldName" [routerLink]="linkForRouter">{{fieldWarning.errorMessage
                | translate}}</a>
        </div>
    </div>
</div>
